<template>
<v-card :color="cardClass(leave)" @click="flipCard">
    <div class="my-card" :class="{'flipped': flipped}">
      <div class="front">
       <v-card-title>{{ leave.ABS_ABSENT_DAYS }} {{ getLeaveTypeName(leave.ABS_ABSENT_TYPE_DOCNO) }}  </v-card-title>
      <v-card-text class="text-truncate text-no-wrap">
        {{ formatDate(leave.ABS_FROMDATE) }} to  
        {{ formatDate(leave.ABS_TODATE) }}        
        </v-card-text>        
      </div>
      <div class="back">
        <v-card-title class="text-truncate text-no-wrap"> {{ leave.ABS_NARRATION }}</v-card-title>
       <v-card-text>
        <span>Created On : {{formatDate(leave.ABS_CREATED_TS ) }} By {{leave.ABS_CREATED_BY}} </span> 
       </v-card-text>
      </div>
    </div>
  </v-card>

</template>

<script>
import moment from 'moment';
export default {
  props: {
    leave: {
      type: Object,
      required: true,     
    },
  },
  data() {
    return {
      flipped: false,
    };
  },
  computed:{
    leavetypes(){
      return this.$store.getters['leavetypes'];
    },
    

  },
  methods:{
    getLeaveTypeName(leaveTypeNo) {
    let leaveType = this.leavetypes.find(type => type.PLV_DOCNO === leaveTypeNo);
    return leaveType ? leaveType.PLV_DESC : '';
    },
    formatDate(date){
      return moment(date).format('DD-MM-YYYY').toString()
    },
    statusInfo(leave){
        let status = null
      if(leave.ABS_POSTED_TS!==null && leave.ABS_POSTED_BY !==null){
        status =`Posted By : ${leave.ABS_POSTED_BY} on:${ this.formatDate(leave.ABS_POSTED_TS)} `
        return status
      }else{
        status ="Processing"
        return status
      }
    },
    cardClass(leave) {       
      return `flip-card ${this.statusInfo(leave) == 'Processing' ? 'processing-card' : 'approved-card'}`;
    },
    flipCard() {
      this.flipped = !this.flipped;
    },
  },
};
</script>

<style scoped>
.my-card {
  margin-top: 2px;
  position: relative;
  height: 75%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
  perspective: 1000px;
  backface-visibility: hidden;
}

.flipped {
  transform: rotateY(180deg);
}
.front{
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.back {
  position: absolute;
  width: 100%;
  height:auto;
  backface-visibility: hidden;
}

.back {
  transform: rotateY(180deg);
}
.processing-card {
  background-color: #fff59d;
}

.approved-card {
  background-color: #c8e6c9;
}
.flip-card {
  height: 100px;
  position: relative;
  width: 100%;
  perspective: 1000px;
  transition: transform 0.6s;
}

/* .flip-card-inner {
  height: 100%;
  position: absolute;
  width: 100%;
  backface-visibility: hidden;
  transition: transform 0.6s;
}

.flip-card-front, .flip-card-back {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  backface-visibility: hidden;
}

.flip-card-front {
  z-index: 2;
}

.flip-card-back {
  transform: rotateY(180deg);
}

.flip-card-inner.flipped {
  transform: rotateY(180deg);
} */

</style>
